import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import configStore from './modules/configStore';
import listingStore from './modules/listingStore';
import layerStore from './modules/layerStore';
import filterStore from './modules/filterStore';
import parcelStore from './modules/parcelStore';
import favStore from './modules/favStore';
import analyticsStore from './modules/analyticsStore';
import Auth from '@/auth/Auth';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    reducer: (state: any) => ({
        // add any states that need to be persisted beyond the current session
        zoom: state.zoom,
        centerLat: state.centerLat,
        centerLon: state.centerLon,
    }),
    // modules: ['listingStore'],
});

export interface State {
    leftDrawerOpen: boolean;
    map: L.Map | null;
    zoom: number;
    centerLat: number;
    centerLon: number;
    isLoggedIn: boolean;
    showWalkabilityHelp: boolean;
    isMapClickDisabled: boolean;
    isMobileBannerDismissed: boolean;
}

export default new Vuex.Store({
    state: {
        leftDrawerOpen: true,
        map: null,
        zoom: -1,
        centerLat: -1,
        centerLon: -1,
        isLoggedIn: false,
        showWalkabilityHelp: true,
        isMapClickDisabled: false,
        isMobileBannerDismissed: false,
    } as State,
    mutations: {
        SET_MAP(state: State, map: L.Map) {
            state.map = map;
        },
        SET_LEFT_DRAWER_OPEN(state: State, isOpen: boolean) {
            state.leftDrawerOpen = isOpen;
        },
        SET_ZOOM(state: State, zoom: number) {
            state.zoom = zoom;
        },
        SET_MAP_CENTER(state: State, mapCenter: L.LatLng) {
            state.centerLat = mapCenter.lat;
            state.centerLon = mapCenter.lng;
        },
        SET_WALKABILITY_HELP(state: State, showWalkabilityHelp: boolean) {
            state.showWalkabilityHelp = showWalkabilityHelp;
        },
        SET_IS_LOGGED_IN(state: State, isLoggedIn: boolean) {
            state.isLoggedIn = isLoggedIn;
        },
        SET_DISABLE_MAP_CLICK(state: State, isDisabled: boolean) {
            state.isMapClickDisabled = isDisabled;
        },
        SET_DISMISS_MOBILE_BANNER(state: State, isDismissed: boolean) {
            state.isMobileBannerDismissed = isDismissed;
        },
    },
    actions: {
        setMap(context, map: L.Map) {
            context.commit('SET_MAP', map);
        },
        setLeftDrawerOpen(context, isOpen: boolean) {
            context.commit('SET_LEFT_DRAWER_OPEN', isOpen);
        },
        setIsLoggedIn(context, isLoggedIn: boolean) {
            context.commit('SET_IS_LOGGED_IN', isLoggedIn);
        },
        initLayers(context) {
            //
        },
        initGeoLocation(context) {
            //
        },
        initWalkTimes(context) {
            //
        },
        initFilters(context) {
            //
        },
        initFavourites(context) {
            //
        },
        showLoginDialog(context) {
            // UNUSED
        },
        login(context, payload) {
            Auth.login();
        },
        logout(context) {
            // TEMP remove persisted data on logout, it should have successfully been added to DB
            context.commit('SET_SAVED_FILTERS', []);
            Auth.logout();
        },

        // EVENT_map_zoom_level_changed
        setZoom(context, zoom: number) {
            context.commit('SET_ZOOM', zoom);
        },

        goToLatLon(context, latLon: L.LatLng) {
            if (context.state.map) {
                context.state.map.setView(latLon, 16);
            }
        },

        // EVENT_map_parcel_click
        parcelClick(context, latLon: L.LatLng) {
            //
        },

        // EVENT_map_move_end
        mapMoveEnd(context, mapCenter: L.LatLng) {
            // components also subscribe to this action
            context.commit('SET_MAP_CENTER', mapCenter);
        },
        notify(context, message: string) {
            //
        },
        setWalkabilityHelp(context, showHelp: boolean) {
            context.commit('SET_WALKABILITY_HELP', showHelp);
        },
        showLightBox(context) {
            //
        },
        showShareDialog(context, mode) {
            //
        },
        showLoginPromptDialog(context, promptContent: string) {
            //
        },
        showRequestSuccess(context) {
            //
        },
        showRequestError(context) {
            //
        },
        setMarkerLocation(context, location: L.LatLng) {
            //
        },
        disableMapClick(context) {
            context.commit('SET_DISABLE_MAP_CLICK', true);
        },
        enableMapClick(context) {
            context.commit('SET_DISABLE_MAP_CLICK', false);
        },
        dismissMobleBanner(context) {
            console.log('action dismissMobleBanner');
            context.commit('SET_DISMISS_MOBILE_BANNER', true);
        },
    },
    plugins: [vuexLocal.plugin],
    modules: {
      config: configStore,
      listings: listingStore,
      layers: layerStore,
      filters: filterStore,
      parcels: parcelStore,
      favourites: favStore,
      analytics: analyticsStore,
    },
});
